module.exports = __webpack_public_path__ + "img/vertical_6_3_8017.a20e772f.png";